import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('CaseImage').create(() => ({
  steamDeckImage: {
    position: 'absolute',
    top: '64px',
    left: '240px',
    width: '200px',
    zIndex: 2,
  },

  boxWrapper: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    justifySelf: 'flex-start',
    width: '100%',
    bottom: '100px',
    paddingBottom: '32px',
  },

  img: {
    position: 'relative',
    maxHeight: '420px',
    top: '100px',
    '&[data-isdifferentpositioning="steamDeck"]': {
      top: '0px',
    },
    '&[data-isdifferentpositioning="ps5"]': {
      top: '10px',
      maxWidth: '300px',
    },
    '&[data-tapps="true"]': {
      top: '50px',
      maxWidth: '400px',
    },
  },
}))
